import { Flex } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { BuyTogetherEffect } from '../../../../typings'
import { messages } from '../messages'
import styles from './styles'

type DiscountLabelProps = {
  discount: number
  list: 1 | 2
}

function DiscountLabel(props: DiscountLabelProps) {
  const { discount, list } = props
  const { formatPercentual } = useNumbers()

  return (
    <Flex className={styles.flexRow}>
      <Tag>{formatPercentual(discount)}</Tag>
      <FormattedMessage {...messages.discount.list} values={{ list }} />
    </Flex>
  )
}

export function BuyTogetherRow(props: { discount: BuyTogetherEffect }) {
  const { discount } = props

  const { trigger, benefit } = discount

  if (!trigger || !benefit) return null

  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage {...messages.discount.title} />
      </SummaryRow.Title>
      <SummaryRow.Value className={styles.valueContentColumn}>
        <DiscountLabel discount={trigger.discount} list={1} />
        <DiscountLabel discount={benefit.discount} list={2} />
      </SummaryRow.Value>
    </SummaryRow>
  )
}
